export enum DeclineReasonEnum {
  CERTIFICATE_NOT_FIT = 'CERTIFICATE_NOT_FIT',
  BAD_PRIOR_EXPERIENCE = 'BAD_PRIOR_EXPERIENCE',
  OTHER_INVITEE_BOOKED = 'OTHER_INVITEE_BOOKED',
  JOB_CANCELLED = 'JOB_CANCELLED',
  OTHER = 'OTHER',
}
